import {
    useCallback,
} from "preact/compat";

import {
    SHORTCUT_DEFINITIONS,
} from "../shortcuts/definitions.ts";

import {
    useKeyboardHandler,
} from "./useKeyboardHandler.ts";

type KeyboardShortcutHandlers = {
    disabled?: boolean;
    onNext?: () => void;
    onPrevious?: () => void;
    onVote?: () => void;
    onFocusTagInput?: () => void;
    onEscape?: () => void;
    onToggleFullscreen?: () => void;
    onShowHelp?: () => void;
    onToggleOcrOverlay?: () => void;
    onToggleAiAnalysis?: () => void;
    onToggleLeftSidebar?: () => void;
    onToggleRightSidebar?: () => void;
    onToggleFilmstrip?: () => void;
    onCrop?: () => void;
    onDownload?: () => void;
    onEdit?: () => void;
    onShare?: () => void;
};

// lookup table built once from the registry for viewer + global shortcuts
const VIEWER_KEY_MAP = new Map<string, string>();
for (const def of SHORTCUT_DEFINITIONS) {
    if (def.context !== "viewer" && def.context !== "global") continue;
    // skip escape and shift+? — handled separately for ordering reasons
    if (def.key === "Escape" || def.shift) continue;
    const normalizedKey = def.key === "Space" ? " " : def.key.toLowerCase();
    VIEWER_KEY_MAP.set(normalizedKey, def.handler);
}

export const useKeyboardShortcuts = (
    handlers: KeyboardShortcutHandlers,
): void => {
    const onKeyDown = useCallback(
        (event: KeyboardEvent) => {
            const key = event.key.toLowerCase();
            const handlerName = VIEWER_KEY_MAP.get(key === " " ? " " : key);
            if (handlerName) {
                const handler =
                    handlers[handlerName as keyof KeyboardShortcutHandlers];
                if (typeof handler === "function") {
                    event.preventDefault();
                    (handler as () => void)();
                }
            }
        },
        [handlers],
    );

    useKeyboardHandler({
        onKeyDown,
        onEscape: handlers.onEscape,
        onShowHelp: handlers.onShowHelp,
        disabled: handlers.disabled,
    });
};
